<template>
  <v-container
    class="fill-height"
    :class="[ !isChecked ? 'container-un-checked': 'checked', $vuetify.breakpoint.xlOnly ? 'shipment-card' : 'shipment-card shipment-card-lg-down', shipment.type, isSelected ? 'selected' : '' ]"
  >
      <v-row no-gutters
      class="fill-height" justify="center" align="center"
      >
        <v-col
          cols="1"
          align-self="center"
          style="padding-top: 6px; padding-left: 4px;"
        >
          <check-circle-icon v-if="isChecked" size="19" :color="iconColor" class="custom-class" :class="[$vuetify.breakpoint.xlOnly ? 'check' : 'check-lg-down']" @click="handleUncheck(shipment.id)"></check-circle-icon>
          <circle-icon v-else size="20" class="custom-class" :class="[$vuetify.breakpoint.xlOnly ? 'check' : 'check-lg-down']" @click="handleCheck(shipment.id)"></circle-icon>
        </v-col>

        <v-col cols="11" @click="handleSelect(shipment.id)">
          <v-row no-gutters>
            <v-col cols="8" align-self="center">
              <v-row no-gutters>
                <template
                  v-if="shipmentTypelayout === 'schedule-layout'"
                >
                  <v-col cols="2" class="pl-1">
                    <v-row no-gutters class="fill-height" justify="start" align="center" :class="[$vuetify.breakpoint.xlOnly ? 'carrier-font-xl' : 'carrier-font-lg-down']">
                      <slot name="carrier" :shipment="shipment"></slot>
                    </v-row>
                  </v-col>
                  <v-col cols="2" class="pl-1">
                    <v-row no-gutters justify="end" :class="[$vuetify.breakpoint.xlOnly ? 'font-xl' : 'font-lg-down']">
                      <slot name="schedule" :shipment="shipment"></slot>
                    </v-row>
                  </v-col>
                </template>
                <template
                  v-else
                >
                  <v-col cols="4" class="pl-1">
                    <v-row no-gutters class="fill-height" justify="start" align="center" :class="[$vuetify.breakpoint.xlOnly ? 'carrier-font-xl' : 'carrier-font-lg-down']">
                      <slot name="carrier" :shipment="shipment"></slot>
                    </v-row>
                  </v-col>
                </template>
                  <v-col cols="4" xl="3" class="pl-1">
                    <v-row no-gutters justify="end" :class="[$vuetify.breakpoint.xlOnly ? 'font-xl' : 'font-lg-down']">
                      <slot name="weight-volume" :shipment="shipment"></slot>
                    </v-row>
                  </v-col>
                  <v-col cols="3" xl="2" class="pl-1">
                    <v-row no-gutters justify="end" :class="[$vuetify.breakpoint.xlOnly ? 'font-xl' : 'font-lg-down']">
                      <slot name="quotes" :shipment="shipment"></slot>
                    </v-row>
                  </v-col>
              </v-row>
          </v-col>

          <v-col offset="1" cols="3" align-self="center">
              <v-row justify="end" no-gutters>
                <v-col cols="3" class="pl-1 icons" align-self="center">
                  <v-row no-gutters justify="center">
                    <slot name="icons" :shipment="shipment"></slot>
                  </v-row>
                </v-col>
                  <v-col cols="9"  align-self="center" :class="[$vuetify.breakpoint.xlOnly ? 'font-xl' : 'font-lg-down']">
                    <slot name="labels" :shipment="shipment"></slot>
                  </v-col>
              </v-row>
          </v-col>
          </v-row>
        </v-col>

      </v-row>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'ShipmentCardGroupByDay',
  components: {},
  props: {
    shipment: Object
  },
  data () {
    return {
        isChecked: false,
        isSelected: false
    }
  },
  computed: {
    ...mapGetters({
      getShipmentIsToggled: ['shipmentsGroupByDay/getShipmentIsToggled'],
      getIsSelectedShipment: ['shipmentsContext/getIsSelectedShipment'],
      getShipmentIsSelecting: 'shipmentsContext/getShipmentIsSelecting'
    }),
    shipmentToggled () {
      return this.getShipmentIsToggled(this.shipment.id)
    },
    shipmentSelected () {
      return this.getIsSelectedShipment(this.shipment.id)
    },
    iconColor () {
      switch (this.shipment.type) {
        case 'OnePL':
          return 'var(--v-wrld_green-base)'
        case 'TwoPL':
          return 'var(--v-wrld_blue-base)'
        case 'ThreePL':
          return 'var(--v-wrld_orange-base)'
        case 'NotTyped':
          return 'var(--v-wrld_grey-base)'
        case 'ShipmentLTL':
          return 'var(--v-wrld_yellow-base)'
        case 'Express':
          return 'var(--v-wrld_black-base)'
        default:
          return 'var(--v-wrld_black-base)'
      }
    },
    shipmentTypelayout() {
      switch (this.shipment.type) {
        case 'OnePL':
        case 'TwoPL':
          return 'schedule-layout'
        default:
          return 'express-layout'
      }
    }
  },
  methods: {
    ...mapActions({
      setToggleShipment: 'shipmentsGroupByDay/setToggleShipment',
      removeToggleShipment: 'shipmentsGroupByDay/removeToggleShipment',
      setSelectedShipment: 'shipmentsContext/setSelectedShipment',
      removeSelectedShipment: 'shipmentsContext/removeSelectedShipment'
    }),
    handleSelect (shipmentID) {
      if (!this.getShipmentIsSelecting) {
        if (this.isSelected === true) {
          this.removeSelectedShipment()
        } else {
          this.setSelectedShipment({shipmentID: shipmentID, shipment: this.shipment })
        }
        this.$emit('card-selected')
      }
    },
    handleCheck (shipmentID) {
      this.setToggleShipment({shipmentID: shipmentID})
      this.$emit('card-checked')
    },
    handleUncheck (shipmentID) {
      this.removeToggleShipment({shipmentID: shipmentID})
      this.$emit('card-unchecked')
    },
  },
  watch: {
    shipmentToggled: {
      deep: true,
      immediate: true,
      handler: function (val, oldVal) {
        this.isChecked = val
      }
    },
    shipmentSelected: {
      deep: true,
      immediate: true,
      handler: function (val, oldVal) {
        this.isSelected = val
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .shipment-card {
    border-radius: 8px;
    border: 2px solid lightgray;
    // border-left: 8px solid lightgray;
    text-decoration: none;
    // padding: 6px;
    display: flex;
    margin-bottom: 8px;
    max-width: 100%;
    margin-left: -24px;
    position: relative;

    cursor: pointer;
    padding: 0;
    background-color: var(--v-wrld_wrld_background-base);
    &.checked {
      padding-left: 12px !important;
      border-left-width: 2px !important;
    }
    &.selected {
      background-color: var(--v-wrld_grey_two-base);
    }
    &.OnePL  {
      border-left-width: 9px;
      border-left-color: var(--v-wrld_green-base);
      &.checked {
        border-color: var(--v-wrld_green-base);
      }
    }
    &.TwoPL {
      border-left-width: 9px;
      border-left-color: var(--v-wrld_blue-base);
      &.checked {
        border-color: var(--v-wrld_blue-base);
      }
    }
    &.ThreePL {
      border-left-width: 9px;
      border-left-color: var(--v-wrld_red-base);
      &.checked {
        border-color: var(--v-wrld_red-base);
      }
    }
    &.Express {
      border-left-width: 9px;
      border-left-color: var(--v-wrld_black-base);
      &.checked {
        border-color: var(--v-wrld_black-base);
      }
    }
    &.NotTyped {
      border-left-width: 9px;
      border-left-color: var(--v-wrld_grey-base);
      &.checked {
        border-color: var(--v-wrld_grey-base);
      }
    }
    .container-un-checked {
      margin-left: -9px;
    }
  }
  .shipment-card-lg-down {
    height: 30%;
  }
  .check {
    cursor: pointer;
    margin-left: 6px;
  }
  .check-lg-down {
    width: 16px;
    height: 16px;
    margin-left: 5px;
  }
  .carrier-font-xl {
    font-size: 16px;
  }
   .carrier-font-lg-down {
    font-size: 13px;
  }
  .font-xl {
    font-size: 14px;
  }
   .font-lg-down {
    font-size: 12px;
  }
  .icons {
    z-index: 9999;
  }
</style>
